import { defineStore } from 'pinia'
import { ref } from 'vue'
import aplosApi from '@/services/aplosApi'
import { toast } from 'vue-sonner'
import { type User } from '@/types'

export const useUserStore = defineStore('user', () => {
  const extraUserData = ref({
    tenant_name: '',
    company_name: '',
    user_allocation: 0
  })

  const userSettings = ref({
    execution_response_limit: 200
  })

  async function fetchUserDetails(user: User) {
    try {

      const { data } = await aplosApi.getUser(user.tenant_id, user.id)
      extraUserData.value = {
        tenant_name: data.tenant.name,
        company_name: data.user.company_name,
        user_allocation: data.tenant.subscription.user_allocation
      }
    } catch (error) {

      if (!user.roles || (user.roles?.length) == 0) {
        const message = "Authorization Error"
        console.error(message)
        toast.error(message, { duration: Infinity, 
          description: "You've logged in successfully. However, there appears to be a problem with your user account. Unfortunately, we cannot retrieve your user role. Please contact technical support or your administrator."
        } );
      } else {
        console.error('Error fetching user details:', error)
      }
    }
  }

  function clearUserStore() {
    extraUserData.value = {
      tenant_name: '',
      company_name: '',
      user_allocation: 0
    }
  
  }

  return { extraUserData, fetchUserDetails, userSettings, clearUserStore }
})


